import { AuthProvider } from "@/context/AuthContext";
import { AdminProvider } from "@/context/AdminContext";
import { OrganisationProvider } from "@/context/OrganisationContext";
import { WebsitesProvider } from "@/context/WebsitesContext";
import { WebsiteSelectionProvider } from "@/context/WebsiteSelectionContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { PostThemesProvider } from "@/context/PostThemesContext";
import { WebsiteContentProvider } from "@/context/WebsiteContentContext";
import { WordPressProvider } from "@/context/WordPressContext";
import { AppStateProvider } from "@/context/AppStateContext";
import { AppChatProvider } from "@/context/AppChatContext";

import { OnboardingProvider } from "@/context/OnboardingContext";
import { SettingsStateProvider } from "@/context/SettingsStateContext";
import { SidebarProvider } from "@/components/ui/sidebar";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";

interface AppContextsProps {
  children: React.ReactNode;
  withSidebar?: boolean;
}

export const AppContexts = ({ children, withSidebar = true }: AppContextsProps) => {
  const contextWrapper = (
    <AuthProvider>
      <AdminProvider>
        <OrganisationProvider>
          <WebsiteSelectionProvider>
            <WebsitesProvider>
              <AppChatProvider>
                <SettingsProvider>
                  <PostThemesProvider>
                    <WebsiteContentProvider>
                      <WordPressProvider>
                        <AppStateProvider>
                          <OnboardingProvider>
                            <SettingsStateProvider>
                              <TooltipProvider>
                                <Toaster />
                                {children}
                              </TooltipProvider>
                            </SettingsStateProvider>
                          </OnboardingProvider>
                        </AppStateProvider>
                      </WordPressProvider>
                    </WebsiteContentProvider>
                  </PostThemesProvider>
                </SettingsProvider>
              </AppChatProvider>
            </WebsitesProvider>
          </WebsiteSelectionProvider>
        </OrganisationProvider>
      </AdminProvider>
    </AuthProvider>
  );

  return withSidebar ? (
    <SidebarProvider>{contextWrapper}</SidebarProvider>
  ) : (
    contextWrapper
  );
};
